import { render, staticRenderFns } from "./CreateCodigoPostalModal.vue?vue&type=template&id=a6aa00a2&"
import script from "./CreateCodigoPostalModal.vue?vue&type=script&lang=js&"
export * from "./CreateCodigoPostalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports